import { Language, LanguageType, TransportModes } from '@nx-smartmonkey/shared/domain';
import { StorageKeys } from '../../../constants/StorageKeys';
import { AuthActions, AuthActionType } from './actions';

const OTP_METHOD = [`sms`, `whatsapp`] as const;
export type OTPMethod = (typeof OTP_METHOD)[number];

export type AuthScreen = `login-welcome` | `login-select-method` | `login-phone` | `login-otp` | `register-data`;

export type SocialLoginProviders = `apple` | `google`;

export interface RegisterDataType {
  phone?: string;
  organizationName?: string;
  location?: { lat: number; lng: number };
  workSchedule?: [number, number];
  vehicleType?: TransportModes;
  language: LanguageType;
  referralId?: string;
  providerToken?: string;
  provider?: SocialLoginProviders;
  accessToken?: string;
}

export interface AuthState {
  authScreen: AuthScreen;
  otpMethod: OTPMethod;
  registerData: RegisterDataType;
}

export const getInitialState = (): AuthState => {
  const otpMethod = (localStorage.getItem(StorageKeys.OTP_METHOD) ?? `sms`) as OTPMethod;
  return {
    authScreen: `login-welcome`,
    otpMethod,
    registerData: {
      language: Language.getDefaultLanguage().value,
    },
  };
};

export const AuthReducer = (state: AuthState, action: AuthActions): AuthState => {
  switch (action.type) {
    case AuthActionType.SET_AUTH_SCREEN:
      return {
        ...state,
        authScreen: action.payload.authScreen,
      };
    case AuthActionType.SET_REGISTER_DATA:
      return {
        ...state,
        registerData: {
          ...state.registerData,
          ...action.payload.registerData,
        },
      };
    case AuthActionType.SET_OTP_METHOD:
      localStorage.setItem(StorageKeys.OTP_METHOD, action.payload.otpMethod);
      return {
        ...state,
        otpMethod: action.payload.otpMethod,
      };
    default:
      return state;
  }
};
